import { BuilderConfig } from '@/types/builder';

import RoomstayBlogSemListSolution, { SemListSolutionProps } from './roomstay-blog-sem-list-solution';

export const RoomstayBlogOurPromiseBuilderConfig = {
    name: 'List Sem Solution',
    inputs: [
        {
            name: 'items',
            type: 'list',
            subFields: [
                {
                    name: 'icon',
                    type: 'file',
                },
                {
                    name: 'title',
                    type: 'html',
                },
                {
                    name: 'description',
                    type: 'html',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<SemListSolutionProps> = {
    component: RoomstayBlogSemListSolution,
    config: RoomstayBlogOurPromiseBuilderConfig,
};

export default builderConfig;
